import React from 'react'

const QuickStatus = ({ selectedTagEmp, descriptionCount }) => {
    return (
        <div className='noti-widget-bg mt-3'>
            <h3 className='color-white mb-2'>Quick Stats</h3>
            <div className='mt-2'>
                <div className='flex-between mb-2'>
                    <span className='lable color-gray'>
                        Character count:
                    </span>
                    <span className='amount color-white'>
                        {descriptionCount}/250</span>
                </div>
                <div className='flex-between mb-2'>
                    <span className='lable color-gray'>
                        Tagged people:
                    </span>
                    <span className='amount color-white'>{selectedTagEmp}</span>
                </div>
                <div className='flex-between'>
                    <span className='lable color-gray'>
                        Attachments:
                    </span>
                    <span className='amount color-white'>1 image</span>
                </div>
                {/* <div className='flex-between'>
                    <span className='lable color-gray'>
                        Estimated reach:
                    </span>
                    <span className='amount astimate-rich'>- 150 employees</span>
                </div> */}
            </div>
        </div>
    )
}

export default QuickStatus
